
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center pt-20">
      <div className="max-w-[1400px] mx-auto px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-primary-dark leading-tight">
                Chaque agglomération mérite ses propres solutions
              </h1>
              <p className="text-base md:text-xl lg:text-2xl text-gray-dark font-light leading-relaxed">
                Nous connectons les acteurs locaux avec les ressources adaptées à leurs besoins spécifiques, qu'ils soient particuliers ou professionnels.
              </p>
            </div>

            <div className="flex flex-wrap gap-5">
              <Link
                to="/particuliers"
                className="inline-flex items-center gap-3 bg-primary text-white px-8 md:px-10 py-3 md:py-4 rounded-full text-sm md:text-base font-medium hover:bg-primary-dark transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Espace Particuliers
                <div className="w-6 h-6 flex items-center justify-center bg-white rounded-full">
                  <i className="ri-arrow-right-line text-primary text-sm"></i>
                </div>
              </Link>
              <Link
                to="/professionnels"
                className="inline-flex items-center gap-3 bg-transparent border-2 border-gray-dark text-gray-dark px-8 md:px-10 py-3 md:py-4 rounded-full text-sm md:text-base font-medium hover:bg-gray-dark hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Espace Professionnels
                <i className="ri-arrow-right-line text-lg"></i>
              </Link>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/ade4afc636f7fe45ffdff9ac1dd61c9d.jpg"
                alt="Vue aérienne d'une agglomération dynamique"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-primary/10 via-transparent to-primary/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
